import { gsap } from 'gsap';
import { checkDeviceType, devices } from '../utils/checkDeviceType';
const components: NodeListOf<Element> = document.querySelectorAll('.teaser');

export class Teaser {
  constructor() {
    if (checkDeviceType() === devices.desktop) {
      components.forEach((component) => {
        this.loadImage(component as HTMLElement);
      });
    }

    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        this.checkOverflow(entry.target as HTMLElement);
      }
    });

    components.forEach((component) => {
      resizeObserver.observe(component);
    });
  }

  loadImage(component: HTMLElement) {
    const backgroundImageContainer = component.querySelector('.teaser-image') as HTMLElement;
    const imageUrl = backgroundImageContainer?.dataset.backgroundImage;
    if (imageUrl) {
      if (!component?.classList.contains('show-image')) {
        let preloadImage: HTMLImageElement | null = document.createElement('img');
        if (preloadImage) {
          preloadImage.src = imageUrl;

          preloadImage.addEventListener('load', (event) => {
            backgroundImageContainer.style.backgroundImage = `linear-gradient(275deg, rgba(0,0,0,0) 20%, rgba(0,0,0,0.3) 50%),url(${imageUrl})`;

            component.classList.add('show-image');
            preloadImage = null;
          });
        }
      }
    }
  }

  checkOverflow(element: HTMLElement) {
    const checkSize = element.querySelector('.check-size') as HTMLElement;
    const textContainer = element.querySelector('.teaser-text-container') as HTMLElement;
    const overlay = element.querySelector('.teaser-overlay') as HTMLElement;
    const imageContainer = element.querySelector('.teaser-image-container') as HTMLElement;
    const text = element.querySelector('.teaser-text-body') as HTMLElement;

    if (window.getComputedStyle(checkSize).display === 'block' && text && textContainer) {
      textContainer.classList.remove('text-overflow');
      overlay.classList.remove('text-overflow');
      imageContainer.classList.remove('text-overflow');

      if (text.clientHeight > 350) {
        textContainer.classList.add('text-overflow');
        overlay.classList.add('text-overflow');
        imageContainer.classList.add('text-overflow');
      }
    } else {
      textContainer.classList.remove('text-overflow');
      overlay.classList.remove('text-overflow');
      imageContainer.classList.remove('text-overflow');
    }
  }
}
